/**
 * Shared metadata for the fixed `yr_place_events.category` vocab.
 *
 * Backing source of truth lives in nodejs_server/controllers/
 * EventsController.js — `CATEGORY_VOCAB`. If a slug is added or removed
 * there, mirror it here. The server coerces unknown slugs to NULL so a
 * drift between client and server surfaces as "no category set" rather
 * than a 500.
 */
import type { PlaceEventCategory } from '@/types/api';

export interface CategoryMeta {
  slug: PlaceEventCategory;
  label: string;
  emoji: string;
  /** Tailwind color used by the map pin + chip (lightweight — no palette fork). */
  color: string;
}

export const EVENT_CATEGORIES: CategoryMeta[] = [
  { slug: 'social',      label: 'Social',      emoji: '🎉', color: '#f472b6' },
  { slug: 'sports',      label: 'Sports',      emoji: '⚽', color: '#22c55e' },
  { slug: 'music',       label: 'Music',       emoji: '🎵', color: '#8b5cf6' },
  { slug: 'food',        label: 'Food',        emoji: '🍽️', color: '#f59e0b' },
  { slug: 'workshop',    label: 'Workshop',    emoji: '🛠️', color: '#0ea5e9' },
  { slug: 'religious',   label: 'Religious',   emoji: '🙏', color: '#a3a3a3' },
  { slug: 'business',    label: 'Business',    emoji: '💼', color: '#64748b' },
  { slug: 'celebration', label: 'Celebration', emoji: '🎊', color: '#ef4444' },
  { slug: 'fitness',     label: 'Fitness',     emoji: '🧘', color: '#14b8a6' },
  { slug: 'other',       label: 'Other',       emoji: '📌', color: '#71717a' },
];

export function categoryMeta(slug: string | null | undefined): CategoryMeta | null {
  if (!slug) return null;
  return EVENT_CATEGORIES.find(c => c.slug === slug) ?? null;
}
